'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('selfAccessRequestControllers')

    .controller('ArrivalSubmitController',
    ['$rootScope', '$scope', '$modal', '$state', '$stateParams', '$translate', 'topBar', 'selfAccessRequestService', 'selfAccessRequest', 'decisionListWithImpact', 'processStep',
        function ($rootScope, $scope, $modal, $state, $stateParams, $translate, topBar, selfAccessRequestService, selfAccessRequest, decisionListWithImpact, processStep) {

        $translate('iam.selfAccessRequest.arrival.submit.pageTitle').then(function(translation) {
            topBar.setTitleAndIcon(translation + ' &nbsp;<i class="fa fa-chevron-right fa-align"></i>&nbsp; ' +
                                    '<i class="' + processStep.CssIcon + '"></i> ' + processStep.StepTitleEN, 'fa-pencil-square-o');
        });

        $scope.processStep = processStep;
        $scope.selfAccessRequest = selfAccessRequest;
        $scope.currentUserId = selfAccessRequest.EmployeeID;
        var systemTypes = [];

        // Load All Decisions Taken

        _.forEach(decisionListWithImpact, function (systemType) {
            systemTypes.push(systemType);
        });

        selfAccessRequestService
            .getSpecialNeedsFollowup($stateParams.userAccessRequestId)
            .then(function (followUp) {
                $scope.specialRequestComment = followUp.Comment;
            });

        $scope.systemTypes = systemTypes;

        // Expand the Systems
        $scope.expand = function (systemType) {
            systemType.IsExpanded = !systemType.IsExpanded;
        }

        // Submit Request
        $scope.submitRequest = function () {

            selfAccessRequestService
                .confirmProcessStepForSelfAccessRequest($stateParams.userAccessRequestId, processStep.Step)
                .then(function () {
                    // Go straight to the completed page: the backend converts the submitted self access request into a
                    // regular one within milliseconds (SelfRequestStatus = NULL), so reloading 'selfAccessRequest' would
                    // land on NoLongerSelfAccessRequest and the ServiceNow follow-up would never open.
                    $state.go('selfAccessRequest.arrival.completed', {
                        userAccessRequestId: $stateParams.userAccessRequestId
                    }, {
                            reload: true
                        });
                });
        }

        // Reset Ownership
        $scope.resetOwnership = function () {
            selfAccessRequestService.cancelSelfAccessRequestOwnership($stateParams.userAccessRequestId)
                .then(function (response) {
                    window.location = environment.iamUrl;
                });
        }


    }]);
